import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../../../.globals/redux/actions";
import { endpoints } from "../../../../../../../../../core/defaultValues";
import {
    clientMutation,
    clientQuery,
} from "../../../../../../../../../core/data/GraphQLApi";
import { ExceptionManager } from "../../../../../../../../../core/logManager";

const INIT_STATE = {
    loading: false,
    error: null,
    create: null,
    update: null,
    deleteComment: null,
    comments: []
};

const route = "modules/workOrders/views/trackerTab/modals/createEditWorkOrder/views/comments/redux/slice";

export const workOrdersSettingsCreateComment = createAsyncThunk(
    "workOrders/comments/createComment",
    async (payload, { rejectWithValue }) => {

        try {
            const mutation = `
              mutation (
                    $workOrderId: Int!
                    $logType: enumWorkOrderLogType!
                    $jsonDetails: AWSJSON!
              ) {
                  data: createWorkOrderLog (
                        workOrderId: $workOrderId
                        logType: $logType
                        jsonDetails: $jsonDetails
                  ) {
                    id
                  }
              }
          `;

            const response = await clientMutation(
                mutation,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );
            return response?.data;

        } catch (exc) {
            ExceptionManager(exc, route, "createWorkOrderLog");
            return rejectWithValue(exc);
        }
    }
);

export const workOrdersSettingsDeleteComment = createAsyncThunk(
    "workOrders/comments/deleteWorkOrderLog",
    async (payload, { rejectWithValue }) => {

        try {
            const mutation = `
              mutation ($id: Int!) {
                  data: deleteWorkOrderLog (id: $id)
              }
          `;

            const response = await clientMutation(
                mutation,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );

            return { delete: response?.data }

        } catch (exc) {
            ExceptionManager(exc, route, "deleteWorkOrderLog");
            return rejectWithValue(exc);
        }
    }
);

export const workOrdersSettingsUpdateComment = createAsyncThunk(
    "workOrders/comments/updateComment",
    async (payload, { rejectWithValue }) => {

        try {
            const mutation = `
              mutation (
                    $id: Int!
                    $jsonDetails: AWSJSON!
              ) {
                  data: updateWorkOrderLog (
                        id: $id
                        jsonDetails: $jsonDetails
                  ) {
                    id
                  }
              }
          `;

            const response = await clientMutation(
                mutation,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );
            return response?.data;

        } catch (exc) {

            ExceptionManager(exc, route, "updateWorkOrderLog");
            return rejectWithValue(exc);
        }
    }
);

export const workOrdersSettingsSearchComments = createAsyncThunk(
    "workOrders/comments/searchComments",
    async ({ workOrderId }, { rejectWithValue }) => {
        try {
            const response = await clientQuery(
                `
                    query ($conditions: [WorkOrderLogSearchInput], $sort: [WorkOrderLogSortInput], $limit: Int, $offset: Int) {
                        data: searchWorkOrderLogs(
                            conditions: $conditions
                            sort: $sort
                            limit: $limit
                            offset: $offset
                        ) {
                            total
                            items {
                                id
                                workOrderId
                                logType
                                jsonDetails
                                updatedBy
                                createdOn
                                updatedOn
                                updatedBy
                                createdBy
                                nameCreatedBy {
                                    id
                                    name
                                }
                            }
                        }
                    }
                `,
                {
                    conditions: [
                        {
                            fields: ["logType"],
                            terms: ["comments"],
                        },
                        {
                            fields: ["workOrderId"],
                            terms: [workOrderId],
                        }
                    ],
                    sort: {
                        "field": "createdOn",
                        "order": "DESC"
                    }
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data?.items || []

        } catch (exc) {
            ExceptionManager(exc, route, "searchWorkOrderLogs");
            return rejectWithValue(exc);
        }
    }
);

const workOrdersCommentsWorkOrderRedux = createSlice({
    name: "workOrders/comments",
    initialState: INIT_STATE,
    reducers: {
        resetWorkOrderComments(state, action) {
            return action.payload
                ? { ...state, ...action.payload }
                : { ...INIT_STATE };
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //workOrdersSettingsCreateWorkOrder
        builder.addCase(workOrdersSettingsCreateComment.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrdersSettingsCreateComment.fulfilled, (state, action) => {
            state.loading = false;
            state.create = action.payload;
        });
        builder.addCase(workOrdersSettingsCreateComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //workOrdersSettingsSearchWorkOrderTypes
        builder.addCase(workOrdersSettingsSearchComments.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrdersSettingsSearchComments.fulfilled, (state, action) => {
            state.loading = false;
            state.comments = action.payload;
        });
        builder.addCase(workOrdersSettingsSearchComments.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //workOrdersSettingsDeleteComment
        builder.addCase(workOrdersSettingsDeleteComment.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrdersSettingsDeleteComment.fulfilled, (state, action) => {
            state.loading = false;
            state.deleteComment = action.payload;
        });
        builder.addCase(workOrdersSettingsDeleteComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //workOrdersSettingsUpdateComment
        builder.addCase(workOrdersSettingsUpdateComment.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrdersSettingsUpdateComment.fulfilled, (state, action) => {
            state.loading = false;
            state.update = action.payload;
        });
        builder.addCase(workOrdersSettingsUpdateComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersCommentsWorkOrderRedux;

// Extract and export each action creator by name
export const {
    resetWorkOrderComments
} = actions;

// Export the reducer, either as a default or named export
export default reducer;
